/**
 * No-op function (does nothing).
 * Use this as a default placeholder to avoid lint warnings on empty functions.
 */

export const noop = (): void => {
  // Intentionally empty
}

export const noopAsync = async (): Promise<void> => {
  // Intentionally empty
}
